import { FileDropZoneModal } from '@payaca/ambrosia';
import { getAcceptedFileTypes } from '@payaca/helpers/fileHelper';
import {
  requestGetUpload,
  requestPersistUpload,
} from '@payaca/store/uploads/uploadsActions';
import { Upload } from '@payaca/types/uploadTypes';
import { MAX_UPLOAD_FILE_SIZE_BYTES } from '@payaca/uploads';
import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

const acceptFileTypes = [...getAcceptedFileTypes(['image']), '.pdf'];

export const ReceiptDocumentUploadModal: FC<{
  isOpen: boolean;
  onClose: () => void;
  onUploadSuccess: (upload: Upload) => void;
}> = ({ isOpen, onClose, onUploadSuccess }) => {
  const dispatch = useDispatch();

  const [showUploadError, setShowUploadError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const onUploadFile = useCallback(
    async (files: File[]) => {
      setShowUploadError(false);
      setIsLoading(true);

      const file = files[0];

      if (!file) return;

      dispatch(
        requestPersistUpload(
          {
            file,
            fileName: file.name,
          },
          (uploadId) => {
            setIsLoading(false);
            if (uploadId) {
              dispatch(
                requestGetUpload(uploadId, (upload) => {
                  onUploadSuccess(upload);
                })
              );
            } else {
              setShowUploadError(true);
            }
          }
        )
      );
    },
    [dispatch, onUploadSuccess]
  );

  return (
    <FileDropZoneModal
      isLoading={isLoading}
      hasError={showUploadError}
      isOpen={isOpen}
      onClose={onClose}
      accepts={{ extensions: acceptFileTypes }}
      dropzoneOptions={{
        multiple: false,
        maxFiles: 1,
        onDrop: (files) => {
          void onUploadFile(files);
        },
        maxSize: MAX_UPLOAD_FILE_SIZE_BYTES,
      }}
    />
  );
};
